const setTimeoutPromise = (time: number): Promise<void> =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });

export default setTimeoutPromise;
